import { render, staticRenderFns } from "./AdsenseHeader.vue?vue&type=template&id=5328ea5d&scoped=true"
import script from "./AdsenseHeader.vue?vue&type=script&lang=js"
export * from "./AdsenseHeader.vue?vue&type=script&lang=js"
import style0 from "./AdsenseHeader.vue?vue&type=style&index=0&id=5328ea5d&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5328ea5d",
  null
  
)

export default component.exports